import { getMandates, Mandate } from "@/api/openapi";
import { PspContext } from "@/config/contexts";
import { useIsTablet } from "@/config/hooks";
import { translate } from "@/config/translator";
import { setSelectedMandateIdStorage } from "@/config/utils";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export function useMandatesMobile() {
  const {
    user,
    lang,
    selectedMandateId,
    setSelectedMandateId,
    setSelectedMandate,
    setCookieConsentDialogOpen,
  } = useContext(PspContext);

  const isTablet = useIsTablet();
  const navigate = useNavigate();

  const [allMandates, setAllMandates] = useState<Mandate[]>();
  const [mandateSearchQuery, setMandateSearchQuery] = useState("");
  useEffect(() => {
    if (
      !user || (
        !user.scopes.includes("admin") &&
        !user.scopes.includes("employee") &&
        !user.scopes.includes("super_employee")
      )
    ) return;
    getMandates({
      query: { limit: 10, offset: 0, query: mandateSearchQuery },
    }).then(({ data, error }) => {
      if (error) {
        toast(translate("somethingWentWrong", lang));
      } else {
        setAllMandates(data);
      }
    });
  }, [lang, mandateSearchQuery]);

  function onSelectMandate(mandate: Mandate) {
    // context
    setSelectedMandate(mandate);
    setSelectedMandateId(mandate.id);

    // local storage
    setSelectedMandateIdStorage(mandate.id);
  }

  return {
    onSelectMandate,
    isTablet,
    navigate,
    selectedMandateId,
    user,
    lang,
    allMandates,
    mandateSearchQuery,
    setMandateSearchQuery,
  };
}
